import { render, staticRenderFns } from "./EditPrixClient.vue?vue&type=template&id=40f81388&"
import script from "./EditPrixClient.vue?vue&type=script&lang=ts&"
export * from "./EditPrixClient.vue?vue&type=script&lang=ts&"
import style0 from "./EditPrixClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports